import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class FrostOverlayMenuService {
    /**
     * A subject that emits when a menu is opened.
     * This is used to close other menus when a new one is opened.
     */
    onMenuOpened: Subject<any> = new Subject<any>();

    constructor() {}
} 